<template>
    <div class="c-table table-config">
        <div class="c-thead">
            <div v-text="'Frakcje zbierane w sklepie'" class="c-td" />
            <div v-text="'Preferowany operator'" class="c-td is-2" />
        </div>
        <div class="c-tbody">
            <div
                v-for="fr in fractions"
                class="c-row"
                :key="fr.id"
            >
                <div class="c-tr flex-md-row align-items-md-center">
                    <div class="c-td">
                        <div class="d-flex">
                            <fraction-label
                                show-details
                                :fraction="fr"
                            />
                        </div>
                    </div>
                    <div class="c-td is-2 pt-0 pt-md-3">
                        <span
                            v-text="'Preferowany operator'"
                            class="typo-label d-flex d-md-none mb-3"
                        />
                        <the-dropdown
                            class="mb-0"
                            v-bind="operatorDropdown(fr)"
                            :options="operators"
                            @onChange="onChangeOpId($event, fr)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { MIX_FRACTION_IDS } from '@/utils/constants/drs/fractions'

export default {
    props: {
        fractions: {
            type: Array,
            required: true
        },
        packageFractionMode: {
            type: String
        }
    },

    data: () => ({
        integratedOperatorIds: []
    }),

    async created() {
        await this.loadIntegratedOperators()
    },

    methods: {
        ...mapActions('drsOperators', ['fetchExternalData']),

        async loadIntegratedOperators() {
            const externalData = await this.fetchExternalData({
                locationId: this.locationId,
                operatorServiceIds: this.getOperators.map(op => op.serviceId)
            }) || []

            this.integratedOperatorIds = externalData
                .filter(op => !!op.collection_point_id)
                .map(op => +op.id)
        },

        onChangeOpId(value, fr) {
            const isMix = this.packageFractionMode === 'MIX' && MIX_FRACTION_IDS.includes(fr.id)

            if (isMix) {
                this.fractions.forEach(f => {
                    if (MIX_FRACTION_IDS.includes(f.id)) {
                        f.dict_operator_id = value
                    }
                })
            } else {
                fr.dict_operator_id = value
            }
        },

        operatorDropdown(fr) {
            const operatorId = fr.dict_operator_id
            const isEp = operatorId && this.operators.some(op => +op.value === +operatorId)

            if (isEp) {
                return {
                    text: 'Operator',
                    firstOption: false,
                    selectedOption: operatorId
                }
            }

            const name = operatorId
                ? this.getAllOperators.find(op => +op.serviceId === +operatorId)?.name
                : null

            return {
                text: name || (this.operators.length ? 'Operator' : 'Brak zintegrowanych operatorów'),
                firstOption: !!name || !this.operators.length,
                selectedOption: ''
            }
        }
    },

    computed: {
        ...mapGetters('drsOperators', ['getOperators', 'getAllOperators']),
        ...mapGetters('drsStores', { locationId: 'getFilterLocationId' }),

        operators() {
            return this.getOperators
                .filter(op => this.integratedOperatorIds.includes(+op.serviceId))
                .map(({ serviceId, name }) => ({
                    value: serviceId,
                    label: name
                }))
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.table-config {
    .is-2 {
        max-width: 20rem;
    }
    @include media-breakpoint-down(xs) {
        .is-2 {
            max-width: 100%;
        }
    }
}
</style>